<template>
  <b-media
    :class="['p-4 rounded', { 'bg-light': ownComment }]"
  >
    <div
      class="mb-2 d-flex align-items-center justify-content-between"
    >
      <div
        v-if="hasAnnotation"
        class="annotation flex-shrink-0"
        data-test="annotation-marker"
      />
      <h6
        :class="['ellipsis mb-0 mr-2', {'ml-2': hasAnnotation}]"
        data-test="commenter-email"
      >
        {{ commentItem.commenterEmail }}
      </h6>
      <time-ago
        class="text-muted small flex-shrink-0"
        :refresh="60"
        :datetime="Date.parse(commentItem.created+ 'Z')"
        locale="en"
      />
    </div>
    <p
      data-test="commenter-feedback"
      class="mb-0"
    >
      {{ commentItem.comment }}
    </p>
  </b-media>
</template>
<script>
import { mapState } from 'vuex';
import TimeAgo from 'vue2-timeago';

export default {
  name: 'CommentItem',
  components: {
    TimeAgo,
  },
  props: {
    commentItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('account', {
      accountEmail: 'email',
    }),
    ownComment() {
      return this.accountEmail === this.commentItem.commenterEmail;
    },
    hasAnnotation() {
      return (this.commentItem.commentLocation);
    },
  },
};
</script>
<style scoped lang="scss">
.annotation {
  position: static;
  display: block;
  background: #3499ad;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #fff;
}
.media-body{
  max-width: 100%;
}
.word-break{
  overflow-wrap: break-word;
  word-wrap: break-word;
}
.v-time-ago__text{
  cursor: default;
}
</style>
